module.exports = __webpack_public_path__ + "img/excel.44930832.svg";